/**
 * In dev (vite serve / `npm run dev`): surfaces the raw technical error so
 * engineers can triage without opening DevTools.
 * In production: returns a generic message to avoid leaking internals.
 *
 * To preview prod-style errors locally without a real build, add
 * VITE_PROD_ERRORS=true to .env.local and restart the dev server.
 *
 * Refine GENERIC_ERROR_MESSAGE text here once copy is decided.
 */
export const GENERIC_ERROR_MESSAGE =
  "Something went wrong. Please try again. If the problem continues, contact support.";

const showRaw =
  import.meta.env.DEV &&
  import.meta.env.VITE_PROD_ERRORS !== "true";

export function toUserMessage(raw: string): string {
  return showRaw ? raw : GENERIC_ERROR_MESSAGE;
}
